import * as Yup from 'yup';

import { userIdSchema } from '../../shared/validation/schemas';
import { CompleteGettingStartedTaskPayload } from '../db/types';

export const COMPLETE_GETTING_STARTED_TASK_SCHEMA = Yup.object().shape<
  CompleteGettingStartedTaskPayload
>({
  userId: userIdSchema,
  completedOn: Yup.date().required('created is required'),
  taskName: Yup.string().required('taskName is required'),
});
